<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main.vue'
import router from '../index'
import { store } from '../../state/store'
import StorageService from '../../services/storage.service'

export default {
  page: {
    title: 'Job Type Select',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout },
  data() {
    return {}
  },
  beforeDestroy() {},
  methods: {
    selectServiceJob() {
      store.resetJobType()
      StorageService.saveServiceJobType()
      router.push('job-lookup')
    },
    selectInstallJob() {
      store.setJobTypeAsInstall()
      StorageService.saveInstallJobType()
      router.push('job-lookup')
    },
  },
}
</script>

<template>
  <Layout>
    <div :class="$style.job_type_select_container">
      <h1 :class="$style.header">SELECT JOB TYPE</h1>
      <div :class="$style.button_container">
        <button
          id="btn-service-job"
          :class="$style.button"
          class="btn btn-primary"
          @click="selectServiceJob"
          >Service Job</button
        >
      </div>
      <div :class="$style.button_container">
        <button
          id="btn-install-job"
          :class="$style.button"
          class="btn btn-primary"
          @click="selectInstallJob"
          >New Account</button
        >
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';
.job_type_select_container {
  max-width: $size-parent-container-width-max;
  text-align: center;
  margin: auto;
  padding: 1em;
}

.header {
  color: $color-text-primary;
  text-align: center;
}

.button {
  padding-left: 2em;
  padding-right: 2em;
  width: 15em;
}

.button_container {
  width: 100%;
  display: block;
  padding: 1em;
}

.spinner_container {
  position: fixed;
  top: 0;
  display: flex;
  align-items: center;
  width: 100%;
  max-width: $size-parent-container-width-max;
  height: 100%;
}

.spinner {
  display: flex;
  margin: 0 auto;
}
</style>
